const capitalizeUserName = function ($name){
  $name = $name.charAt(0).toUpperCase() + $name.slice(1);
  return $name;
};

const nullornot = (value) => {
  if(value == null)
    return "Address not available";
  else
    return value;
};

export { capitalizeUserName, nullornot };



// WEBPACK FOOTER //
// ./client/utils/stringsFormatting.js